import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { GetDataProductResponseDto } from '@/api';
import i18n from '@/i18n';
import SChip from '@/components/SChip.vue';
import { SChipColors } from '@/components/SChipTypes';

interface DataProductQualityStatusProps {
  status: GetDataProductResponseDto.dataProductStatus | GetDataProductResponseDto.dataProductUpstreamStatus;
}

type ChipInfo = {
  text: string;
  color: SChipColors;
  icon: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DataProductQualityStatus',
  props: {
  status: null
},
  setup(__props) {

const props = __props;


const chip = _computed((): ChipInfo => {
  switch (props.status) {
    case GetDataProductResponseDto.dataProductStatus.HEALTHY:
      return { text: i18n.t('qualityStatus.data_products_labels.healthy') as string, color: SChipColors.SUCCESS, icon: 'icon-check-circle-fill' };
    case GetDataProductResponseDto.dataProductStatus.AT_RISK:
      return { text: i18n.t('qualityStatus.data_products_labels.at_risk') as string, color: SChipColors.WARNING, icon: 'icon-warning-fill' };
    case GetDataProductResponseDto.dataProductStatus.CRITICAL:
      return { text: i18n.t('qualityStatus.data_products_labels.critical') as string, color: SChipColors.FAILURE, icon: 'icon-error-circle-fill' };
    default:
      return { text: i18n.t('qualityStatus.data_products_labels.not_supported') as string, color: SChipColors.NEUTRAL, icon: 'icon-circle-slash' };
  }
});

return { __sfc: true,props, chip, _computed, GetDataProductResponseDto, i18n, SChip, SChipColors }
}

})